/* eslint-disable @typescript-eslint/lines-between-class-members */
/* eslint-disable class-methods-use-this */
import * as React from 'react';
import {
  CellTemplate,
  Cell,
  Compatible,
  Uncertain,
  getCellProperty,
  keyCodes,
} from '@silevis/reactgrid';

export interface FlagCell extends Cell {
  type: 'flag';
  text: string;
  rowId: string;
}
export class HeaderCell implements CellTemplate<FlagCell> {
  getCompatibleCell(uncertainCell: Uncertain<FlagCell>): Compatible<FlagCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = Number.parseFloat(text);
    return { ...uncertainCell, text, value } as Compatible<FlagCell>;
  }

  handleKeyDown(
    cell: Compatible<FlagCell>,
    keyCode: number,
  ): { cell: Compatible<FlagCell>; enableEditMode: boolean } {
    if (keyCode === keyCodes.ENTER) {
      return { cell, enableEditMode: true };
    }
    return { cell, enableEditMode: false };
  }

  getClassName(cell: any): string {
    const isValid = cell.validator ? cell.validator(cell.text) : true;
    const className = cell.className || '';
    return `${className} ${isValid ? 'valid' : 'invalid'} ${
      cell.placeholder && cell.text === '' ? 'placeholder' : ''
    }`;
  }

  render(cell: Compatible<FlagCell>) {
    return (
      <p
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          maxWidth: '150px',
          textOverflow: 'ellipsis',
          fontSize: '13px',
          fontWeight: '500',
          fontFamily: 'Roboto Regular',
          lineHeight: '18px',
        }}
      >
        {cell.text}
      </p>
    );
  }
}
